module.exports = {

    demoResultsBase: '/api/results/demo',
    resultsBase: '/api/results/v2/',

    isEmpty(obj) {

        for (const key of Object.keys(obj)) {

            const el = obj[key];

            if( el.length > 0 )
                return false;

        }

        return true;

    },

    // -----------
    // Usually results load before filters, when it is loaded, the results reload once again
    // Since the `selectedFilters` have changed from an empty object to an object with all property keys
    // which contains empty arrays of selected filters.
    // -----------
    // First, we check if both values are empty (either an empty object or with empty arrays)
    // Then we check for the both values not to be equal - 
    // for some reason there are cases in $watch statements where it shows that both values are equal even though they shouldn't be.
    // -----------
    bothEmptyFilters(oldVal, newVal)
    {
        return this.isEmpty(oldVal) && this.isEmpty(newVal) && oldVal !== newVal
    },

    getEndpoint: (url) => {
        const base = (window.__results_props__.is_demo) ? module.exports.demoResultsBase : module.exports.resultsBase;
        return window.endpoint_ish + base + url;
    },

    getEndpointPython: (url) => {
        return window.endpoint_python + '/' + url;
    },

    getPillarIdentifiers: (periodIndex) => {

        let data = {
            pillar_ids: pillar_ids,
            filters: formattedFilters
        };

        data = Object.assign(data, window.__results_props__.period_identifiers[periodIndex]);

    },

    getIdentifiers: () => {

        let periodIdentifiers = [];

        // 0

        if(window.__results_props__.is_demo){
            periodIdentifiers[0] = {public_url: window.__results_props__.survey_id};
        }
        else if(window.__results_props__.orgtype == 'period'){
            periodIdentifiers[0] = {parent_period_id: parseInt(window.__results_props__.survey_id)};
        }
        else if(window.__results_props__.orgtype == 'survey'){
            periodIdentifiers[0] = {survey_id: parseInt(window.__results_props__.survey_id)};
        }
        else{
            periodIdentifiers[0] = {period_id: parseInt(window.__results_props__.survey_id)};
        }

        // 1

        if (window.__results_props__.is_comparison) {

            if(window.__results_props__.is_demo){
                periodIdentifiers[1] = {public_url: window.__results_props__.survey_id2};
            }
            else if(window.__results_props__.orgtype == 'period'){
                periodIdentifiers[1] = {parent_period_id: parseInt(window.__results_props__.survey_id2)};
            }
            else if(window.__results_props__.orgtype == 'survey'){
                periodIdentifiers[1] = {survey_id: parseInt(window.__results_props__.survey_id2)};
            }
            else{
                periodIdentifiers[1] = {period_id: parseInt(window.__results_props__.survey_id2)};
            }

            // this.loadComparedResults();

        }

        return periodIdentifiers;

    },

    getPostData(periodIndex) {
        // console.log(window.__results_props__)
        return Object.assign({}, window.__results_props__.period_identifiers[periodIndex]);
    }

}
